import {ssrSafeDocument} from '@github-ui/ssr-utils'

type DataRouterMatch = {
  route?: {id?: string}
  staticData?: {dataRouterId?: string}
}

type DataRouterReactApp = HTMLElement & {
  routerOrHistory?: {state?: {matches?: DataRouterMatch[]}}
}

const ROUTE_ID_META_SELECTOR = 'meta[name="data-router-route-id"]'

/** Returns the deepest canonical route ID from the active Data Router app. */
export function getCurrentRouteId(): string | undefined {
  const reactApp = ssrSafeDocument?.querySelector<DataRouterReactApp>('react-app[data-data-router-enabled="true"]')
  const matches = reactApp?.routerOrHistory?.state?.matches

  if (Array.isArray(matches)) {
    for (let index = matches.length - 1; index >= 0; index--) {
      const match = matches[index]
      const routeId = match?.staticData?.dataRouterId ?? match?.route?.id
      if (routeId) return routeId
    }
  }

  return ssrSafeDocument?.querySelector<HTMLMetaElement>(ROUTE_ID_META_SELECTOR)?.content || undefined
}
